export default __webpack_public_path__ + "static/media/e_wdt_c_3.80865244.mp3";